import { isEmpty } from 'underscore';
import React from 'react';
import URI from 'urijs';
import { AxiosError } from 'axios';
import { useAxios } from '../Components/Auth';
import { useLogger } from '../Components/Logger';

export const useInviteCode = () => {
  const { idTokenInstance } = useAxios();
  const logger = useLogger();
  const hasSentInviteCode = React.useRef(false);

  const inviteCode = React.useMemo(() => {
    const uri = new URI(window.location.href);
    const query = uri.query(true);
    return query.inviteCode as string;
  }, []);

  const sendInviteCode = React.useCallback(async (code: string) => {
    if (idTokenInstance && !isEmpty(code) && !hasSentInviteCode.current) {
      try {
        const response = await idTokenInstance.post(`${process.env.REACT_APP_API_URL}/Public/InviteCode?code=${code}`);
        hasSentInviteCode.current = true;

        if (response.status !== 200) {
          // eslint-disable-next-line @typescript-eslint/no-throw-literal
          throw response;
        }

        logger.logInfo(`Sent invite code: ${code}`);
      } catch (error) {
        logger.logError(`Failue to send invite code: ${JSON.stringify({
          code,
          status: (error as AxiosError)?.response?.status,
          result: (error as AxiosError)?.response?.data,
        })}`);
      }
    }
  }, [idTokenInstance, logger]);

  return {
    inviteCode,
    sendInviteCode,
  };
};
